import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=6220c2eb&scoped=true&"
import script from "./step1.vue?vue&type=script&lang=js&"
export * from "./step1.vue?vue&type=script&lang=js&"
import style0 from "./step1.vue?vue&type=style&index=0&id=6220c2eb&scoped=true&lang=scss&"
import style1 from "./step1.vue?vue&type=style&index=1&id=6220c2eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220c2eb",
  null
  
)

export default component.exports